import { defineMessages } from '@skippay/core/i18n/intl';

export default defineMessages({
	'labels.loading': {
		id: 'labels.loading',
		defaultMessage: 'Než řeknete švec, stránka se načte',
	},
	'labels.total': {
		id: 'labels.total',
		defaultMessage: 'Celkem',
	},
	'labels.toSignInScreen': {
		id: 'labels.toSignInScreen',
		defaultMessage: 'Zpět na přihlášení',
	},
});
